import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { t } from '../utils/translate';
import './Footer.css';

const Footer = () => {
  const { language } = useLanguage();
  const slogan = t('footer.slogan', language);

  // 突出显示slogan中的daydaygo
  const renderSlogan = () => {
    if (typeof slogan !== 'string') return slogan;
    
    // 根据语言匹配daydaygo（可能大小写不同）
    const daydaygoRegex = /(daydaygo|DayDayGo|DAYDAYGO)/i;
    const match = slogan.match(daydaygoRegex);
    
    if (match) {
      const parts = slogan.split(daydaygoRegex);
      const daydaygoText = match[0];
      
      return (
        <p>
          {parts[0]}
          <span className="daydaygo-highlight">{daydaygoText}</span>
          {parts[2]}
        </p>
      );
    }
    
    return <p>{slogan}</p>;
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          {/* <h3>{t('footer.title', language)}</h3> */}
          {renderSlogan()}
        </div>
        <div className="footer-section">
          <p>{t('footer.tel', language)}</p>
          <p>{t('footer.email', language)}</p>
          <p>{t('footer.address', language)}</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>{t('footer.copyright', language)}</p>
      </div>
    </footer>
  );
};

export default Footer;
